// @flow

import React from 'react';
import classnames from 'classnames';
import ClientConfig from '../../../context/clientConfig';
import ClientPage from '../../../context/clientPage';
import {
  getLabel, getPlaceholder, getPinErrorMsg, shouldMarkInputError,
} from '../../../../helpers/formatUtils';
import { getMaxPinLength } from '../../../../helpers/validateWBI';
import i18n from '../../../../i18n';

type Props = {
  pinLength: string | Array<number>,
  handleUpdatePinConfig: Function
};

class PinNoField extends React.Component<Props> {
  componentDidMount(): void {
    const {
      handleUpdatePinConfig, pinLength, pinType, pinTruncate,
    } = this.props;
    if (pinLength !== null) {
      handleUpdatePinConfig(pinLength, pinType, pinTruncate);
    }
  }

  render() {
    const { pinLength, pinType } = this.props;
    return (
      <ClientConfig.Consumer>
        {clientConfig => {
          const {
            pinInputLabel,
            pinLabelTooltipComponent,
            pinErrorMsg,
            showLabels,
            pinInputPlaceholder,
            pinInputRequiredMark,
            inputClassNames,
            labelClassNames,
            labelAnimation,
            showPinNumCounter,
            customNS,
            showPinErrorMsgOnBlank
          } = clientConfig;
          return (
            <ClientPage.Consumer>
              {({ pageData, actions, formState }) => {
                const { pin, touched, focused } = pageData;
                const { handleChange, handleBlur, handleFocus } = actions;

                const hasError = shouldMarkInputError('pin', pin, showPinErrorMsgOnBlank, touched, focused, formState.errors);

                const errorMsg = getPinErrorMsg(pinLength, pinErrorMsg);

                const isActive = focused.pin;

                const label = getLabel(pinInputLabel, showLabels, isActive);

                const placeholder = getPlaceholder(pinInputPlaceholder, isActive);

                const maxLength = getMaxPinLength(pinLength);

                return (
                  <>
                    {label
                      && (
                        <label
                          htmlFor='pin'
                          className={classnames(
                            labelClassNames,
                            labelAnimation && isActive ? 'field-active' : '',
                            hasError ? 'errorLabel' : '',
                          )}
                        >
                          {i18n.t(label, {ns: customNS})}
                          {pinInputRequiredMark && (<span className='pinInputRequiredMark'>{pinInputRequiredMark}</span>)}
                        </label>
                      )}
                    {pinLabelTooltipComponent}
                    <input
                      value={pin}
                      id='pin'
                      type={pinType}
                      name='pin'
                      placeholder={i18n.t(placeholder, {ns: customNS})}
                      maxLength={maxLength}
                      aria-label={i18n.t('Please enter PIN', {ns: customNS})}
                      aria-describedby='pin_error'
                      className={classnames(
                        `form-control ${inputClassNames}`,
                        isActive ? 'input-active' : '',
                        {
                          error: hasError,
                        },
                      )}
                      onFocus={() => handleFocus('pin')}
                      onBlur={e => handleBlur('pin')}
                      onChange={e => handleChange('pin', e.target.value)}
                      required
                    />
                    {showPinNumCounter && typeof pinLength === 'string' && (
                      <p id='pinNumCounter'>
                        {pin.length}
                        /
                        {maxLength}
                      </p>
                    )}
                    {hasError && (
                      <div className='w-100'>
                        <small id='pin_error' className='error_text' aria-live='polite'>{i18n.t(errorMsg, {ns: customNS})}</small>
                      </div>
                    )}
                  </>
                );
              }}
            </ClientPage.Consumer>
          );
        }}
      </ClientConfig.Consumer>
    );
  }
}

export default PinNoField;
